// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__Z3DYX","row":"styles_row__rwbY9"};